import { useCallback } from 'react';
import { useHistory } from 'react-router';

type UseBackButtonNavigationCallback = (to?: string, reportUsageCallback?: () => void) => () => void;
export const useBackButtonNavigationCallback: UseBackButtonNavigationCallback = (to, reportUsageCallback) => {
  'use memo';

  const history = useHistory();

  return useCallback(() => {
    reportUsageCallback?.();

    if (to) {
      history.push(to);
    } else if (history.length > 0) {
      history.goBack();
    } else {
      history.push('/');
    }
  }, [history, to, reportUsageCallback]);
};
